module.exports = {"title":"Privacy","component":"ContentPage","html":"<p>Privacy declaration.</p>\n"};